/**
 * @module app.cd
 */

import { bindingMode, autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { LookupService } from 'app/cd/services/lookup-service';
import { LookupService as CoreLookupService } from 'app/core/services/lookup-service';
import { IUserSearchFilters } from "app/core/services/user-service";
import { IQueryLoadOptions } from 'app/shared/lib/api/api-types';
import { apiCall } from 'app/shared/lib/api/api';
import { MemberFilters } from 'app/shared/config/modules';
import * as Core from 'app/core/models/essette-api';
import { NamespaceOptions } from 'app/shared/lib/i18n';

export type AvailableFilters = 'active' | 'login.loginName' | 'application.description' | 'login.lastLogInDateTimestamp' | 'name.first' | 'name.last' | 'emailAddress' |
    'title' | 'department'

@autoinject
export class UserFiltersCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    public searchFilters: IUserSearchFilters = {};

    @bindable.objectNull()
    public availableFilters: AvailableFilters[] | null = [
        'active', 'login.loginName', 'application.description', 'login.lastLogInDateTimestamp', 'name.first', 'name.last', 'emailAddress',
        'title', 'department'
    ];

    @bindable.stringNull()
    public requiredFilters: string | null = null;

    @bindable.stringNull()
    public module: string | null = null;

    @bindable.string()
    public i18nNamespace: Extract<NamespaceOptions, NamespaceOptions.Core> = NamespaceOptions.Core;
    public applications: ReadonlyArray<Core.Application> | null = [];

    @bindable.string()
    public ariaLabelledbyId: string = '';

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected readonly service: LookupService,
        protected readonly coreService: CoreLookupService,
        protected readonly userFilters: MemberFilters,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.toggleActiveUsersOnly(this.searchFilters.active || true);
        this.loadLookups();
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected filterVisible(filterName: AvailableFilters): boolean {
        let filter = this.userFilters.getFilter(filterName);

        if(filter) {
            if(this.module && this.module !== filter.moduleCode) {
                let index = filter.showInModules ? filter.showInModules.indexOf(this.module) : -1;
                if(index < 0) { return false; }
            }
        }

        if(this.availableFilters) {
            let index = this.availableFilters.indexOf(filterName);
            if(index < 0) { return false; }
        }

        return true;
    }

    protected toggleActiveUsersOnly(value: boolean): void {
        this.searchFilters.active = value;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadLookups(): Promise<void> {
        const options: Partial<IQueryLoadOptions> = {
            all: true
        };

        try {
            this.state.beginLoad();
            const response = this.filterVisible('application.description') ? await this.coreService.loadApplications(options, []) : null;
            this.applications = response?.results || [];
            if(this.applications.length != 0) {
                this.applications = this.applications.filter(applications => applications.code === 'Suite' || applications.code === 'Portal.Providers');
            }
        }
        catch(error) {
            this.logger.error('Error Loading Lookups', error);
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
